import React from 'react'
import { useNavigate } from 'react-router-dom'

import DarazManual from 'app/common/Stores/Daraz/DarazManual'
import WooCommerceManual from 'app/common/Stores/Woo/WooCommerceManual'
import {
  PixelButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelHeaderPanel,
  PixelImage,
} from 'pixel-base'
import { IPixelFactory } from 'client/../decl'

interface Store {
  slug: string
  name: string
  icon: React.ReactNode
}

interface ManualFlowProps {
  activeStore: Store
  onBack: () => void
}

const ManualFlow = ({ activeStore, onBack }: ManualFlowProps) => {
  const navigate = useNavigate()

  const { showSuccess } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const onSuccessAddStore = () => {
    showSuccess('Successfully Added')
    navigate('/admin/stores')
  }

  const renderManualFlows = () => {
    switch (activeStore.slug) {
      case 'daraz':
        return (
          <DarazManual
            origin="settings"
            onSuccessAddStore={onSuccessAddStore}
          />
        )
      case 'woocommerce':
        return <WooCommerceManual />
      default:
        return null
    }
  }

  return (
    <PixelFlexBox
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="stretch"
      width="100%"
      style={{
        border: '1px solid #e8eaed',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
        overflow: 'hidden',
        // maxWidth: '560px',
      }}
    >
      <PixelHeaderPanel
        height="auto"
        alignContent="center"
        backgroundColor="#fafafa"
        padding="16px 24px"
      >
        <div
          style={{
            borderBottom: '1px solid #e8eaed',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <PixelFlexBox alignItems="center" gap="12px">
            {typeof activeStore.icon === 'string' ? (
              <PixelImage height="40px" src={activeStore.icon} />
            ) : (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {activeStore.icon}
              </span>
            )}
            <span
              style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#1a1d21',
              }}
            >
              {activeStore.name}
            </span>
          </PixelFlexBox>
          <PixelButton variant="secondary" onClick={onBack}>
            Back
          </PixelButton>
        </div>
      </PixelHeaderPanel>
      <PixelFlexBox
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        padding="24px 28px"
        width="100%"
      >
        {renderManualFlows()}
      </PixelFlexBox>
    </PixelFlexBox>
  )
}

ManualFlow.displayName = 'ManualFlow'

export default ManualFlow
